import { withStylePrefix } from '../common/withStylePrefix';
import { LaunchScreenComponent, launchScreenComponentTemplate } from './LaunchScreen';
import styles from './LaunchScreen.styles.scss';
export const launchScreenDefinition = {
    baseName: 'launch-screen',
    template: launchScreenComponentTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonLaunchScreen = LaunchScreenComponent.compose(launchScreenDefinition);
